import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=200752a7&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=200752a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200752a7",
  null
  
)

export default component.exports